import React, { useContext, useEffect, useState } from "react"
import { withRouter } from "react-router"

import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined"
import PublishOutlinedIcon from "@material-ui/icons/PublishOutlined"
import { TextField } from "@material-ui/core"
import { Fab } from "@material-ui/core"
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined"
import Chip from "@material-ui/core/Chip";
import DoneIcon from "@material-ui/icons/Done";
import { Delete, Search } from "@material-ui/icons";
import CloseIcon from '@material-ui/icons/Close'
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import Typography from "@material-ui/core/Typography";

import AlertContext from "../../context/alert/alertContext"
import AuthContext from "../../context/authentication/authContext"
import TableContext from "../../context/table/tableContext"
import BillContext from "../../context/bill/BillContext"

import AlertMui from "../core/AlertMui"
import useMediaQuery from "../../hooks/useMediaQuery"
import BillTable from "./BillTable"
import { ReactComponent as ArrowDown } from "../../assets/icon/keyboard_arrow_down-24px.svg";

import "./bills.css"


const useStyles = makeStyles((theme) => ({
  containerTabs: {
    margin: "auto",
    textAlign: "center",
  },
  tabs: {
    marginLeft: "30px",
    color: "#707070",
    "&:hover": {
      color: "#12b1ee !important",
      borderBottom: "solid 1px #12b1ee",
    },
  },
  title:{
    fontFamily:'Poppins',
    fontStyle:"normal",
    fontWeight:'400',
    fontSize:'32px',
    lineHeight:'20px',
    color:'#001070',
    marginBottom:'10px',
    marginLeft:'62px'
  },

  gridContainer: {
    width:"100%",

},

topButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "right",
  padding:"10px, 20px",
  gap: "10px",
  hover:"#001070",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
button:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
deleteButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#DA291D",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  marginRight:"14px",
  '&:hover': {
    backgroundColor: '#DA291D',
    transform: 'translateY(-1px) !important'}

},

  importButton:{

    fontFamily:'Inter',
    fontStyle: 'normal',
    fontWeight:'500',
    fontSize:'14px',
    lineHeight: '20px',
    color:"#ffffff",
    backgroundColor: "#001070",
    textTransform: 'capitalize',
    padding: "10px, 20px",

  },
  search:{
    border: "1px solid #E8E9EA",
    padding: "15px 0px 15px 15px",
    width:"150px",
    height:"43px",
    marginRight:"10px",
    marginBottom:"30px",
    marginTop:"20px",
    backgroundColor: "#FFFFFF",
    borderColor:"#E8E9EA",
    borderRadius:"6px",
    fontFamily:"Poppins",
    fontSize:"16px",

  },
  searchName:{
    border: "1px solid #E8E9EA",
    padding: "15px 0px 15px 15px",
    width:"291px",
    height:"43px",
    marginBottom:"30px",
    marginTop:"20px",
    backgroundColor: "#FFFFFF",
    borderColor:"#E8E9EA",
    borderRadius:"6px",
    fontFamily:"Poppins",
    fontSize:"16px",

  },
  searchDate:{  
    fontFamily:"Poppins",
    fontSize:"14px",
    width:"150px",
    height:"43px",
    marginRight:'10px',
    padding: "5px 5px 5px 5px",
    border: "1px solid  rgb(133, 133, 133)",

    fontFamily: 'monospace',
    paddingInlineStart: '1px',
    cursor: 'default',
    alignItems: 'center',
    display: 'inline-flex',
    overflow: 'hidden',
    padding: '0px',
    borderStyle: 'inset',
    borderColor: '-internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133))'
  },

  buttonSearch:{
    width:"123px",
    height:"40px",
    borderRadius:"6px",
    padding:"10px, 20px",
    borderColor:"#E8E9EA",
    backgroundColor: "#DA291D",
    color: "#ffffff",
    textAlign:"center",
    fontSize:"14px",
  },
  subTitle:{
    fontSize: "14px",
    color: "#414141",
    font: "Bold 14px/16px Roboto;",
    letterSpacing: "0px",
    opacity: 1,
    fontWeight: "bold",
    },


    closeIcon: {
      fontSize: 16,
      marginLeft: theme.spacing(0.5),
      cursor: 'pointer',
    },

    filters:{
      display: "flex", 
      margin: "25px",
      flexWrap:'wrap',
      flexDirection:'column',
      alignContent: 'flex-start',
      alignItems: 'flex-start'
    },
    
  labelCheckbox: {
    fontSize: "14px",
    marginTop: "2px",
  },
}))

const BillsTables = (props) => {
  const classes = useStyles()
  const documentTypes = {
      33: "F. Afecta",
      34: "F. Exenta",
      52: "G. Despacho",
      61: "N. Crédito",
      56: "N. Débito",
      46: "F. Compra"
    }
  const isProvider = props.type === 2
  const isMobile = useMediaQuery("max-width", 600)
  const columnsBills = [
    { name: "Fecha" },
    { name: "Hora" },
    { name: "Tipo" },
    { name: "Folio" },
    { name: "Monto" },
    { name: "Estado" },
    { name: "Acciones" }
  ]
  const authContext = useContext(AuthContext)
  const {  authenticatedUser } = authContext
  const tableContext = useContext(TableContext)
  const alertContext = useContext(AlertContext);
  const {
      error,
      setMaxPerPage,
  } = tableContext

  const { alert, showAlert } = alertContext
  const {
        getBillAll,
        currentPage,
        maxPerPage,
        currentType,
        currentFrom,
        currentUntil,
        customerId,
        shopId,
        setBillAllParams,
        filterCriteria,
        exportBill,
        clear
  } = useContext(BillContext)

  const [filters, setFilters] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [showDocTypes, setShowDoctypes] = useState(true);

  function _export(){

    props.setModalTitle("Espere un momento, estamos enviando datos al email....")
    props.showModal()
    exportBill(customerId,shopId)
  }
  function _search(event){
       const params={}
       params[event.currentTarget.attributes.param.value] = event.currentTarget.value
       params.currentPage=1
       params.maxPerPage=10
       setBillAllParams(params)
       setFilters({...filters, TEXT: event.currentTarget.value});
  }
  function _searchDates(){
     try{
         //console.log('_searchDates',currentPage,maxPerPage,currentType,currentFrom,currentUntil,customerId,shopId)
         const params={}
         const f = document.getElementById('currentFrom')
         const u = document.getElementById('currentUntil')
         if(f&&f.value&&f.value!='') {
          const val = f.value.split('-')
          params['currentFrom'] =  val[2]+'-'+val[1]+'-'+val[0]
         }
         if(u&&u.value&&u.value!=''){
           const val = u.value.split('-')
           params['currentUntil'] = val[2]+'-'+val[1]+'-'+val[0]
         }
         setFilters({...filters, DATEFROM: params['currentFrom'], DATEUNTIL: params['currentUntil']});
         params.currentPage=1
         params.maxPerPage=10
         setBillAllParams(params)
     }catch(err){
        //console.error(error)
     }
  }
  function handleDeleteFilter(filter) {
   const params = {
      currentPage: 1,
      maxPerPage: 10,
    };
    switch(filter){
        case 'TEXT':
            document.getElementById('outlined-search').value = ''
            _search({currentTarget:{attributes:{param:{value:'filterCriteria'}},value:''}})
            break
        case 'DATEFROM':
            document.getElementById('currentFrom').value = null
             params.currentFrom= null
            _searchDates()
            break
        case 'DATEUNTIL':
            document.getElementById('currentUntil').value = null
             params.currentUntil= null
            _searchDates()
            break
        case 'DOCTYPE':
            params.currentType= null
            setFilters( {...filters, DOCTYPE:null})
            break
    }
    setBillAllParams(params);
  }
  function getSelectedFilters() {
    return filters.filter(
      (filter) =>
        isSelectedType(currentType, filter) === "selectedType"
    );
  }
  function _filterType(event){

    const selectedType = event.currentTarget.attributes.type;
    if (selectedType) {
      const params = {
        currentType: selectedType.value,
        currentPage: 1,
        maxPerPage: 10,
      };
      setBillAllParams(params);
      setFilters({...filters, DOCTYPE: documentTypes[selectedType.value]});
    } else {
     // setFilters([]);
      setBillAllParams((prevState) => ({
        ...prevState,
        currentType: null,
        currentPage: 1,
      }));
    }

//    //console.log(event.currentTarget.attributes.type)
    if(event.currentTarget.attributes.type){
       const params={}
       params.currentType =event.currentTarget.attributes.type.value
       params.currentPage=1
       params.maxPerPage=10
       setBillAllParams(params)
    }

  }
  function isSelectedType(type){
    ////console.log(type)
    return currentType == type ? 'selectedType':''
  }
  function handleShowDocTypes(){
    setShowDoctypes(!showDocTypes)
  }
  const selectedFilters = [];
  if (error) {
    props.history.push("/app/error")
  }

  useEffect(() => {
      authenticatedUser()
      const customers = JSON.parse(localStorage.getItem('customers'))
      setBillAllParams({
        customerId:customers[0].id,
        shopId:customers[0].shops[0].id,
        currentPage:1,
        maxPerPage:10
      })
    }, [])
  useEffect(() => {
       if(currentPage&&maxPerPage&&customerId&&shopId){
            clear()
            getBillAll(customerId,shopId,currentType,currentFrom,currentUntil,currentPage,maxPerPage,filterCriteria)
       }
  }, [currentPage,maxPerPage,currentType,currentFrom,currentUntil,customerId,shopId,filterCriteria])

  return (
<div>
      <Grid container spacing={1}>

          <Grid item xs={12} style={{    display: "flex",  flexDirection: "row",
    justifyContent: "space-between", alignItems: "center",}}>
                      <div className={classes.title}>
            Ventas
          </div>
            <div>
              <button  style={{
                            padding:"10px 20px",
                            background: "#001070",
                            borderRadius:"6px",
                            marginRight:"15px",
                            fontEeight: "500",
                            fontSize: "14px",
                            lineHeight: "20px",
                            textAlign:"center",
                            color:"#ffffff",
                            cursor:"pointer"
                         }}
                    onClick={_export}
                    >Enviar datos por Email</button>
            </div>  
          </Grid>
          <Grid item  xs={3}>
          <div>
            <div style={{ marginTop: "25px"}}>
              <TextField
                id="outlined-search"
                type="search"
                variant="outlined"
                placeholder="Folio"
                onChange={_search}
                style={{
                  width: "90%",
                  backgroundColor: "white",
                }}
                inputProps={{param:"filterCriteria"}}
                InputProps={{
                  endAdornment: (
                    <SearchOutlinedIcon
                      style={{ color: "#707070" }}
                      position="end"
                    ></SearchOutlinedIcon>
                  ),
                }}
              />
            </div>

 {/* componente que renderiza los filtros aplicados */
          <div style={{ display: "flex", marginTop: "25px" }}>
          <FilterListOutlinedIcon style={{ color: "#707070" }} />
          <Typography className={classes.labelCheckbox}>
            Filtros aplicados
          </Typography>
          </div>}
          <div className={classes.filters}>
                    { filters['TEXT'] && <Chip
                        key={'textfilter'}
                        label={filters['TEXT']}
                        color="primary"
                        style={{
                          marginLeft: "10px",
                          marginTop: "10px",}}
                        clickable
                        onClick={() => handleDeleteFilter('TEXT')}
                        className={classes.chip}
                      /> }
                      { filters['DATEFROM'] && <Chip
                              key={'DATEFROMtextfilter'}
                              label={filters['DATEFROM']}
                              color="primary"
                              style={{
                                marginLeft: "10px",
                                marginTop: "10px",}}
                              clickable
                              onClick={() => handleDeleteFilter('DATEFROM')}
                              className={classes.chip}
                            /> }
                      { filters['DATEUNTIL'] && <Chip
                                key={'DATEUNTILtextfilter'}
                                label={filters['DATEUNTIL']}
                                color="primary"
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "10px",}}
                                clickable
                                onClick={() => handleDeleteFilter('DATEUNTIL')}
                                className={classes.chip}
                              /> }
                      { filters['DOCTYPE'] && <Chip
                                      key={'DOCTYPEtextfilter'}
                                      label={filters['DOCTYPE']}
                                      color="primary"
                                      style={{
                                        marginLeft: "10px",
                                        marginTop: "10px",}}
                                      clickable
                                      onClick={() => handleDeleteFilter('DOCTYPE')}
                                      className={classes.chip}
                                    /> }
            </div>
            <div className={classes.subTitle}>Fecha</div>
            <div style={{ height: "60px", marginTop: "10px" }}>
            <input
              type="text"
              placeholder="Desde"
              id="currentFrom"
              className={classes.searchDate}
              style={{ width: "125px", height: "32px" }}
              onFocus={(e) => (e.currentTarget.type = "date")}
            />
            <input
              type="text"
              placeholder="Hasta"
              id="currentUntil"
              className={classes.searchDate}
              style={{
                width: "125px",
                height: "32px",
                marginLeft:  "0px",
              }}
              onFocus={(e) => (e.currentTarget.type = "date")}
            />
            <Fab
              size="small"
              aria-label="add"
              onClick={_searchDates}
              style={{
                backgroundColor: "#12b1ee",
                marginLeft: "8px",
                marginTop:  "2%",
              }}
            >
              <ArrowForwardIosOutlinedIcon style={{ color: "white" }} />
            </Fab>
            </div>
          </div>
          
          <div>
              <div style={{ marginBottom: "25px", marginTop:'10px' }} className={classes.subTitle}>
                Tipo de Venta
                <ArrowDown style={{ cursor: "pointer" }} onClick={handleShowDocTypes}/>
              </div>
              { showDocTypes &&
                <>
                  <div onClick={_filterType} type={33} style={{cursor:'pointer'}} className={isSelectedType(33)}>F. Afecta</div>
                  <div onClick={_filterType} type={34} style={{cursor:'pointer'}} className={isSelectedType(34)}>F. Exenta</div>
                  <div onClick={_filterType} type={52} style={{cursor:'pointer'}} className={isSelectedType(52)}>G. Despacho</div>
                  <div onClick={_filterType} type={61} style={{cursor:'pointer'}} className={isSelectedType(61)}>N. Crédito</div>
                  <div onClick={_filterType} type={56} style={{cursor:'pointer'}} className={isSelectedType(56)}>N. Débito</div>
                  <div onClick={_filterType} type={46} style={{cursor:'pointer'}} className={isSelectedType(46)}>F. Compra</div>
                </>
              }
            </div>
          </Grid>
          <Grid item xs={9}>
            <BillTable
              columns={columnsBills}
              maxPerPage={maxPerPage}
              setMaxPerPage={setMaxPerPage}
              showReferencesOptions = {props.showReferencesOptions}
            />
          </Grid>
      </Grid>
  </div>
  )
}
export default withRouter(BillsTables)
